import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import Box from '@magalu/stereo-ui/atoms/Box';
import { getTextColor, themeGet } from '@magalu/stereo-ui-styles';
import styled from 'styled-components';
import { StarGroup } from '@magalu/stereo-ui-icons';
import { Chip } from '@magalu/stereo-ui/atoms';
export var Content = styled(Box).attrs(function (props) {
  return _extends({
    px: 3
  }, props);
})(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
export var Description = styled(Box).attrs(function (props) {
  return _extends({
    color: 'text.base',
    fontWeight: 'regular',
    lineHeight: 'big',
    textAlign: 'justify'
  }, props);
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
export var StyledChip = styled(Chip)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: #edf8ff;\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  padding: 4px 8px;\n  margin-right: 8px;\n  border-radius: ", ";\n"])), function (props) {
  return getTextColor('primary')(props);
}, themeGet('fontSizes.1'), themeGet('fontWeights.medium'), themeGet('radii.default'));
export var StyledStarGroup = styled(StarGroup)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-right: 8px;\n  color: ", ";\n"])), function (props) {
  return getTextColor('primary')(props);
});
export var WarningGenAI = {
  alignItems: 'center',
  color: '#697277',
  display: 'flex',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '18px',
  marginBottom: '32px',
  marginTop: '10px'
};